import type { TerminalBatchAddDto } from "src/app/features/Terminal/types/TerminalBatchAddDto";
import type { TerminalBatchAddEntity } from "src/app/features/Terminal/types/TerminalBatchAddEntity";

export const TerminalBatchAddEntityToBatchAddDto = ({ ...rest }: Readonly<TerminalBatchAddEntity>): TerminalBatchAddDto => {
    return { ...rest };
};
